import React, { useState } from 'react'
import { Typography, useDimensions } from '@telavita-core/react-design-kit'
import ReactJoyride, { CallBackProps, STATUS } from 'react-joyride'

import Tooltip from 'components/Tooltip'
import { ReactComponent as ArrowIcon } from 'static/svg/onboarding-arrow-icon.svg'

import { useOctadeskChat } from 'hooks'
import disableScroll from 'utils/disableScroll'

import * as S from './styles'

type OnBoardingStatus = typeof STATUS[keyof typeof STATUS]

interface TooltipWrapperProps {
  isMobile: boolean
  children: React.ReactNode
}

const textMobile = (
  <Typography inheritColor center variant="content2" weight='bold'>
    Seja bem vindo(a). <br /> Para marcar uma consulta, é <br /> só interagir com este botão.
  </Typography> 
)

const textDesktop = (
  <Typography inheritColor variant="content2" weight='bold'>
    Seja bem vindo(a). Para marcar uma consulta, é só interagir com este botão.
  </Typography>
)

const SCHEDULE_ONBOARDING_KEY = '@telavita_schedule_onboarding'

const TooltipWrapper = ({isMobile,  children }: TooltipWrapperProps) => (
  <S.TooltipWrapper isMobile={isMobile}>
    {children}
  </S.TooltipWrapper>
)

export const ScheduleButtonOnboarding = (): JSX.Element => {
  const { isMobile } = useDimensions()
  const [onBoardingStatus, setOnBoardingStatus] = useState<OnBoardingStatus>(STATUS.IDLE)
  const onboardingStatusOnLocalStorage = localStorage.getItem(SCHEDULE_ONBOARDING_KEY)
  useOctadeskChat({ hide: onBoardingStatus === STATUS.RUNNING})

  const handleJoyrideCallback = (data: CallBackProps) => {
    if (data.status === STATUS.RUNNING) {
      setOnBoardingStatus(STATUS.RUNNING)
      return disableScroll.on()
    }
  
    if (data.status === STATUS.FINISHED) {
      setOnBoardingStatus(STATUS.FINISHED)
      localStorage.setItem(SCHEDULE_ONBOARDING_KEY, JSON.stringify(STATUS.FINISHED))
      disableScroll.off()
    }
  }

  return (
    <ReactJoyride
      run={onboardingStatusOnLocalStorage !== JSON.stringify(STATUS.FINISHED)}
      callback={handleJoyrideCallback}
      tooltipComponent={(props) => (
        <TooltipWrapper isMobile={isMobile}>
          <Tooltip {...props} />
        </TooltipWrapper>
      )}
      steps={
        [
          {
            content: (
              <S.ContentContainer isMobile={isMobile}>
                {isMobile ? textMobile : textDesktop}
                <ArrowIcon />
              </S.ContentContainer>
            ),
            target: '.FloatActionButtonDropdown__Button',
            placement: `${isMobile ? 'bottom' : 'left-start'}`,
            offset: 1,
            disableBeacon: true,
          },
        ]
      }
      disableOverlayClose
      disableScrolling
      spotlightPadding={2}
      styles={{
        options: {
          arrowColor: 'transparent',
          overlayColor: 'rgba(0, 0, 0, 0.75)',
        },
        spotlight: {
          borderRadius: 40,
          border: '3px solid #fff',
        },
      }}
    />
  )
}